export const referrer = () => {
    return document.referrer || 'direct none';
};
